module.exports = __webpack_public_path__ + "img/bb_g1_t_eyes-02.6e45c4d1.svg";